export default __webpack_public_path__ + "static/media/delivery.bac2c202.svg";